class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;
    this.hoverTimer = null;

    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', () => {
        window.clearTimeout(this.hoverTimer);
      });
    }
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.hoverTimer);
    this.hoverTimer = window.setTimeout(() => {
      document.querySelectorAll('header-menu .mega-menu[open]').forEach((menu) => {
        if (menu !== this.mainDetailsToggle) menu.closest('header-menu').close();
      });
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }, 180);
  }

  onMouseLeave() {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;

    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.hoverTimer);
    this.closeTimer = window.setTimeout(() => this.close(), 140);
  }

  close() {
    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.hoverTimer);
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
